<template>
    <div id="menberMoveTree">
        <div class="tree-wraper">
            <el-tree 
                v-loading="treeloading"
                element-loading-text="拼命加载中..." 
                :data="deptreedata" 
                :props="defaultProps" 
                @node-click="handleNodeClick"
                node-key="id"
                default-expand-all
                :highlight-current="true">
                <span class="custom-tree-node" slot-scope="{ node}" >
                     
                     <el-tooltip class="item" effect="dark" :content="node.label" placement="top">
                       <span class="custom-label" >{{ node.label }}</span>
                    </el-tooltip>
                </span>    
            </el-tree>
        </div>

        <div  style="text-align:center;margin:30px 0px">
            <el-button @click="cancleMove">取 消</el-button>
            <el-button type="primary" @click="confirmMove">确 定</el-button>
        </div>
        
    </div>
</template>

<script>
    import {GetEnterpriseDepartmentApi} from '@/js/enterPriseApi.js'
    import {mydebounce} from '@/js/common.js'
    export default {
        data(){
            return {
                treeloading:false,
                deptreedata:[],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                currentselectDepid:'',

            }
        },
        created() {
            if(window.localStorage.getItem('enterPriseId')){
                // this.GetEnterpriseDepartment({
                //     enterpriseId:localStorage.getItem('enterPriseId'),
                // })
            }
        },
        methods:{
            handleNodeClick(data,node){
             
                this.currentselectDepid=''
                this.currentselectDepid=data.id
            },
            cancleMove(){
                this.$emit('closeMoveDialog')
            },
            confirmMove:mydebounce(function(){
                if(this.currentselectDepid){
                    this.$emit('ConfirmMoveDialog',this.currentselectDepid)
                }else{
                    this.$message.error('请选择目标部门')
                }
            },500),
            GetEnterpriseDepartment(params){
                let that=this;
                this.deptreedata=[];
                this.currentselectDepid='';
                that.treeloading=true;
                GetEnterpriseDepartmentApi(params)
                .then(res=>{
                    if(res.status===200 && res.data.error_code===0){
                        const {data}=res.data;
                        console.log(data)

                        let treeArr=this.toTreeData(data)
                        this.deptreedata=treeArr;
                        that.treeloading=false;
                    }else{
                        this.$message.error(res.data.error_msg)
                        that.treeloading=false;
                    }
                })
                .catch(err=>{
                    that.treeloading=false;
                    if(err.data && err.data.errorMessages){
                        that.$message.error(err.data.errorMessages[0]);
                    }else if(err.data){
                        that.$message.error(err.data);
                    }
                })  
            },
            toTreeData(data, attr) {//将父子关系的数组转化为树结构
                let tree = [];
                let resultLevelArr=[]
                for(let i=0;i<100;i++){//根据level找出顶级元素
                    resultLevelArr=data.filter(item=>{
                        return item.level===i
                    })
                    if(resultLevelArr.length){
                        break
                    }
                }
                resultLevelArr.map(item =>{
                        let obj = {
                            id:item.enterpriseDepartmentId,
                            label:item.departmentName,
                            parentId:item.parentId,
                            level:item.level,
                            children:[]
                        }
                        tree.push(obj)//把最外层父级push进去
                })
                
                let res=this.childerData(tree,data)
                return res
            },
            childerData(tree,data){
                for(let i=0;i<tree.length;i++){//循环树形父级元素
                    for(let j = 0;j<data.length;j++){//循环数据
                    //判断数据的pid是不是等于父级的id，如果是则代表是当前父级的子级
                        if(tree[i].id == data[j].parentId){
                            let obj = {
                                id:data[j].enterpriseDepartmentId,
                                label:data[j].departmentName,
                                children:[],
                                level:data[j].level,
                                parentId:data[j].parentId,
                            }
                            tree[i].children.push(obj);//加入到父级的子级数组中
                        }
                    }
                    this.childerData(tree[i].children,data)//递归调用自己，传入第二层元素 
                }
                return tree
            },
        }
    }
</script>

<style lang="scss" scoped>
    #menberMoveTree{
        
        text-align: left;
        
        .tree-wraper{
            padding: 20px 10px 20px 10px;
            margin: 20px 20px 20px 20px;
            border: 1px solid #ECECEC;
            border-radius: 2px;
            .custom-tree-node{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    .custom-label{
                        padding: 2px 2px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }  
            }
        }
        /deep/ .el-tree-node__content{
                    padding: 2px 2px;
                    height:30px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #333;
                    .el-tree-node__label{
                        font-size: 14px !important;
                    }
                }
        /deep/ .el-tree--highlight-current
                .el-tree-node.is-current
                > .el-tree-node__content {
                // 设置颜色
                background-color: #F4F5F6;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #0069e0;
                background: #E8F4FF;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/companyManage/menberMoveTree.vue